import { render, staticRenderFns } from "./agreement-category-fields.vue?vue&type=template&id=aa9366f4&scoped=true&"
import script from "./agreement-category-fields.vue?vue&type=script&lang=js&"
export * from "./agreement-category-fields.vue?vue&type=script&lang=js&"
import style0 from "./agreement-category-fields.vue?vue&type=style&index=0&id=aa9366f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9366f4",
  null
  
)

export default component.exports